import { Grid, Box, Stack } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ControlledTextInput, WsButton } from 'wisestep-base';

import FAQDetailsDetailsCommonFields from '../FAQDetailsCommonFields';
import FAQDetailsPage from '../FAQDetailsPage';

const DataPrivacy = () => {
  const methods = useForm();

  const dataPrivacy = [
    {
      title: 'Q: How do I manage Data Privacy of Candidates ?',
      text: 'A: Wisestep takes Data Privacy Seriously. All Candidates Records have Data Privacy options and you can mark Candidates to be added to the Resctrict List, Forget List or the Delete List.',
      optionalText: '',
    },
    {
      title: 'Q: What happens to Candidates in the Forget List ?',
      text: 'A: Candidates from the forget List will show up with just their Jobs contacted for details and No contact information visible.You cannot see any information for them or map them to any Job.',
      optionalText: '',
    },
    {
      title: 'Q: What happens to Candidates in the Delete List ?',
      text: 'A: Candidates from the Delete List will not show up in the Search and all their Contact information (except email address) along with “ Jobs contacted for”, CVs, Conversations are Deleted from the Wisestep platform.Any submissions made to clients are not deleted.',
      optionalText:
        'Email address are retained so that if someone adds the Candidate again by mistake, they are reminded that the Candidate is on the delete list.',
    },
    {
      title: 'Q: What happens to Candidates in the Restrict List ?',
      text: 'A: The Restrict list is a forget list with an end date. It behaves like a Forget list except that the Recruiter or the Candidate know that the Candidate will move back to a normal state once the end date is reached.During this time the Candidate contact   details and other contact information is not visible.',
      optionalText: '',
    },
    {
      title: 'Q:How do I remove Candidates from Forget, Restrict or Delete List',
      text: 'A: All Candidate records whether on the Mapping pages or Search Candidate pages have Data Privacy buttons.Click on the button and then select the“ Open for Communication”    option, specify your reason and enable the Candidate to be removed from the list.All  actions for this activity are logged so you always know which user did what.',
      optionalText: '',
    },
  ];

  const [dataPrivacyList, setDataPrivacyList] = useState<
    { title: string; text: string; optionalText: string }[] | undefined
  >(dataPrivacy);

  const [textValue, setTextValue] = useState('');

  const handleOnClick = () => {
    const findText =
      dataPrivacy && dataPrivacy?.length > 0
        ? dataPrivacy?.filter((b) => b?.title.toUpperCase().includes(textValue.toUpperCase()))
        : undefined;
    setDataPrivacyList(findText);
  };
  return (
    <FAQDetailsPage>
      <Box pt={2}>
        <FormProvider {...methods}>
          <Grid item xs={12} pb={2} bgcolor="white" p={2}>
            <Stack direction="row" spacing={1}>
              <ControlledTextInput
                placeholder="Search..."
                name="search"
                type="text"
                fullWidth
                required
                autoComplete="text"
                value={textValue}
                onChange={(e) => setTextValue(e.target.value)}
              />
              <WsButton disabled={!textValue} size="large" onClick={handleOnClick}>
                Search
              </WsButton>
            </Stack>
          </Grid>
          <Grid container spacing={2} pt={2}>
            {dataPrivacyList &&
              dataPrivacyList?.length > 0 &&
              dataPrivacyList?.map((list, index) => (
                <Grid item xs={12} key={index}>
                  <FAQDetailsDetailsCommonFields
                    title={list.title}
                    text={list.text}
                    optionalText={list.optionalText}
                  />
                </Grid>
              ))}
          </Grid>
        </FormProvider>
      </Box>
    </FAQDetailsPage>
  );
};

export default DataPrivacy;
